import React, {useEffect, useRef, useState} from 'react';
import {Distribution, DropdownItemType, Trust} from "../../../model/EstateFlowchartTypes";
import {isTrust} from "../../../utils/DefUtils";
import TrustForm from "../TrustForm/TrustForm";
import NonTrustDistributionForm from "../NonTrustDistributionForm/NonTrustDistributionForm";
import AddOrCopyDistributionSection from "../../AddOrCopyDistributionSection/AddOrCopyDistributionSection";
import {v4 as randomUuid} from "uuid";

interface DistributionListProps {
    distributions: Distribution[];
    updateEstateItem: (distributions: Distribution[]) => void;
    saveForm: () => Promise<boolean>;
    pageIndex: number;
    addDistributionOptions: DropdownItemType[];
}

const DistributionList = ({
                              distributions,
                              updateEstateItem,
                              saveForm,
                              pageIndex,
                              addDistributionOptions,
                          }: DistributionListProps) => {

    const [distributionList, setDistributionList] = useState<Distribution[]>(distributions);
    const [distributionKeys, setDistributionKeys] = useState<string[]>([])
    const flagDelete = useRef<boolean>(false);

    useEffect(() => {
        setDistributionList(distributions);
        if (distributionKeys.length === 0) {
            const initialKeys = distributions.map(() => randomUuid());
            setDistributionKeys(initialKeys);
        }
    }, [distributions]);

    const updateRemainderDistribution = (newDistribution: Distribution | undefined, index: number) => {
        const distributions = [...distributionList];
        if (newDistribution) {
            distributions[index] = newDistribution;
        }
        setDistributionList(distributions);
        updateEstateItem(distributions);
    };

    const deleteDistribution = async (index: number) => {
        const distributions = [...distributionList];
        const updatedKeys = [...distributionKeys];

        distributions.splice(index, 1);
        updatedKeys.splice(index, 1);

        setDistributionList(distributions);
        setDistributionKeys(updatedKeys);
        updateEstateItem(distributions);
        flagDelete.current = true;
    };

    const renderTrustForm = (distribution: Distribution, sectionIndex: number) => {
        return <TrustForm
            key={distributionKeys[sectionIndex]}
            pageIndex={pageIndex}
            sectionIndex={sectionIndex}
            trustInfo={distribution as Trust}
            deleteDistribution={() => deleteDistribution(sectionIndex)}
            updateDistribution={updateRemainderDistribution}
        />
    }

    const renderNonTrustForm = (distribution: Distribution, sectionIndex: number) => {
        return <NonTrustDistributionForm
            key={distributionKeys[sectionIndex]}
            pageIndex={pageIndex}
            sectionIndex={sectionIndex}
            distributionInfo={distribution}
            deleteDistribution={() => deleteDistribution(sectionIndex)}
            updateDistribution={updateRemainderDistribution}
        />
    }

    return (
        <>
            {
                distributionList?.map((distribution, sectionIndex) => {
                    return isTrust(distribution.distributionType) ?
                        renderTrustForm(distribution, sectionIndex) :
                        renderNonTrustForm(distribution, sectionIndex)
                })
            }
            <AddOrCopyDistributionSection
                distributionTypeDropdownOptions={addDistributionOptions}
                distributions={distributionList ?? []}
                setDistributions={(updatedDistributions) => {
                    if (updatedDistributions.length !== distributionList.length) {
                        const newKeyList = updatedDistributions.map((_, index) =>
                            distributionKeys[index] || randomUuid()
                        );
                        setDistributionKeys(newKeyList);
                    }
                    setDistributionList(updatedDistributions)
                    updateEstateItem(updatedDistributions);
                }}/>
        </>
    );
};

export default DistributionList;